module.exports = __webpack_public_path__ + "static/media/staking-illust.4fb24c0b.png";